import { Button } from 'src/shared/components/ui'

export const TabButton = ({
  selected,
  onClick,
  children,
  className = '',
  ...props
}) => (
  <Button
    type="button"
    variant="ghost"
    size="default"
    className={`uppercase tracking-wide text-xs px-0 py-1 my-1 h-auto rounded-none border-0 border-b-2 text-foreground bg-transparent ${className}`}
    style={{
      boxShadow: 'none',
      borderBottom: selected ? '2px solid black' : '2px solid white',
      color: selected ? 'black' : 'rgba(0, 0, 0, 0.6)',
    }}
    onClick={onClick}
    {...props}
  >
    {children}
  </Button>
)
